import React from 'react';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';
import { Button } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const CustomizationDetailsAddDressing = (props: Props) => {
  const { onPress } = props;

  const { formatMessage } = useIntl();

  return (
    <Button
      size="large-wide"
      palette="kale"
      accessibilityRole="link"
      accessibilityLabel={formatMessage(messages.title)}
      onPress={onPress}
    >
      <FormattedMessage {...messages.title} />
    </Button>
  );
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  title: {
    defaultMessage: 'Add dressing',
    description: 'Customization | Add dressing CTA | Title',
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  onPress: () => void;
};
